import { trackEvent } from './trackEvent';

export const trackLink = (
    clickEvent: React.MouseEvent,
    eventName99d: string,
    eventNameVistaprint: string,
    properties: BaseTracking
) => {
    if (clickEvent.metaKey || clickEvent.ctrlKey || clickEvent.altKey || clickEvent.shiftKey) {
        trackEvent(eventName99d, eventNameVistaprint, properties);
        return;
    }

    clickEvent.preventDefault();

    trackEvent(eventName99d, eventNameVistaprint, properties);

    const href = (clickEvent.currentTarget as HTMLAnchorElement).getAttribute('href');

    if (!href) return;

    window.setTimeout(() => {
        window.location.assign(href);
    }, 300);
};
